import { fromJS } from 'immutable';

import {
  integrationAuthorizationUrl,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  REFRESH_IN_PROGRESS,
  REFRESH_SUCCESS,
  SIGN_IN,
} from './types';

const initialState = fromJS({
  accessToken: null,
  tokenPayload: false,
  expiresAt: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  refreshing: false,
  integrationAuthorization: {
    url: '',
    network: {
      error: false,
      loading: false,
    },
  },
});

export * from './actions';

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return state.set('loading', true);

    case REFRESH_IN_PROGRESS:
      return state.set('refreshing', true);

    case LOGIN_SUCCESS:
    case REFRESH_SUCCESS:
      return state.withMutations((s) =>
        s
          .set('loading', false)
          .set('isAuthenticated', true)
          .set('accessToken', action.payload.accessToken)
          .set('tokenPayload', fromJS(action.payload.tokenPayload))
          .set('expiresAt', action.payload.expiresAt)
          .set('error', false)
          .set('refreshing', false),
      );

    case LOGIN_FAILURE:
      return state.withMutations((s) =>
        s
          .set('loading', false)
          .set('isAuthenticated', false)
          .set('accessToken', null)
          .set('tokenPayload', false)
          .set('expiresAt', null)
          .set('error', action.error)
          .set('refreshing', false),
      );

    case integrationAuthorizationUrl.request:
      return state.setIn(['integrationAuthorization', 'network', 'loading'], true);

    case integrationAuthorizationUrl.success:
      return state.withMutations((s) =>
        s
          .setIn(['integrationAuthorization', 'network', 'loading'], false)
          .setIn(['integrationAuthorization', 'network', 'error'], false)
          .setIn(['integrationAuthorization', 'url'], action.response),
      );

    case integrationAuthorizationUrl.failure:
      return state.withMutations((s) =>
        s
          .setIn(['integrationAuthorization', 'network', 'loading'], false)
          .setIn(['integrationAuthorization', 'network', 'error'], action.error),
      );

    case SIGN_IN.request:
      return state.withMutations((s) =>
        s.set('loading', true).set('error', null).set('refreshing', true),
      );

    case SIGN_IN.success:
      return state.withMutations((s) => s.set('loading', false).set('refreshing', false));

    case SIGN_IN.failure:
      return state.withMutations((s) =>
        s.set('loading', false).set('refreshing', false).set('error', action.error),
      );

    default:
      return state;
  }
}
